import { CreateSearchAgency, ProductCommissionAgency, SearchAgency } from "../redux/slice/agency/AgencySlice";
import { ADD_AGENCY_PRODUCT_COMMISSION_URL, EDIT_AGENCY_PRODUCT_COMMISSION_URL, EDIT_AGENCY_URL, GET_ACTIVE_OVERRIDE_AGENCY_LIST_URL, GET_AGENCY_BY_ID_URL, GET_AGENCY_BY_USER_URL, GET_AGENCY_INFO_WITH_PRODUCT_USER_AND_COMMISSION_URL, GET_AGENCY_LIST_URL, GET_ASSOCIATE_AGENCY_LIST_URL, GET_IS_V3_AGENCY_EXISTS_URL, GET_OVERRIDE_AGENCY_BY_PRACTICE_ID, GET_PRODUCT_COMMISSIONS_BY_AGENCY_ID_URL, INACTIVATE_AGENCY, SAVE_AGENCY_URL } from "./URL";
import { http } from "./http";

export const saveAgencyData = async (agency: CreateSearchAgency) => {
    try{
        const response = await http.post(SAVE_AGENCY_URL, agency);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const editAgencyData = async (agency: CreateSearchAgency) => {
    try{
        const response = await http.post(EDIT_AGENCY_URL, agency);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const searchAgencyData = async (agency: SearchAgency) => {
    try{
        const response = await http.post(GET_AGENCY_LIST_URL, agency);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const getAgencyDataById = async (agencyId: number) => {
    try{
        const response = await http.get(GET_AGENCY_BY_ID_URL, {
            params: {
                agencyId
            }
        });
        return response;
    }
    catch(error){
        throw error;
    }
};
//CS-431
export const getAgencyInfoWithProductUserAndCommissionUrl = async (agencyId: number) => {
    try{
        const response = await http.get(GET_AGENCY_INFO_WITH_PRODUCT_USER_AND_COMMISSION_URL + `/${agencyId}`);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const inactivateAgency = async (agencyId: number) => {
    try {
        const response = await http.post(`${INACTIVATE_AGENCY}/${agencyId}`);
        return response;
    } catch (error) {
        throw error;
    }
};
//
export const getAssociateAgencyList = async () => {
    try{
        const response = await http.get(GET_ASSOCIATE_AGENCY_LIST_URL);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const getAgencyByUser = async () => {
    try{
        const response = await http.get(GET_AGENCY_BY_USER_URL);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const getProductCommissionsByAgencyId = async (agencyId: number, currentPage: number, itemsPerPage: number) => {
    try{
        const response = await http.get(GET_PRODUCT_COMMISSIONS_BY_AGENCY_ID_URL, {
            params: {
                agencyId, currentPage, itemsPerPage
            }
        });
        return response;
    }
    catch(error){
        throw error;
    }
};

export const addAgencyProductCommissionData = async (agency: ProductCommissionAgency) => {
    try{
        const response = await http.post(ADD_AGENCY_PRODUCT_COMMISSION_URL, agency);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const editAgencyProductCommissionData = async (agency: ProductCommissionAgency) => {
    try{
        const response = await http.post(EDIT_AGENCY_PRODUCT_COMMISSION_URL, agency);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const getIsV3AgencyExists = async () => {
    try{
        const response = await http.get(GET_IS_V3_AGENCY_EXISTS_URL);
        return response;
    }
    catch(error){
        throw error;
    }
};

//cs-1191 - Start 
export const getAllActiveOverRideAgencyList = async () => {
    try{
        const response = await http.get(GET_ACTIVE_OVERRIDE_AGENCY_LIST_URL);
        return response;
    }
    catch(error){
        throw error;
    }
};
//CS-1191 - End

//cs-1234 - Start 
export const getOverrideAgencyCommissionsByPracticeId = async (practiceId: number) => {
    try{
        const response = await http.get(`${GET_OVERRIDE_AGENCY_BY_PRACTICE_ID}/${practiceId}`);
        return response;
    }
    catch(error){
        throw error;
    }
};
//CS-1234 - End